import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LocationLink } from "@/components/Sections/PriceComparison/components/LocationLink";
import { Section, Title } from "@/components/UI";
import { usePriceComparison } from "@/contexts/classified";
import { useRefsContext } from "@/contexts/ref";
import { useBrandContext } from "@/shared/contexts";
import { useI18n } from "@/shared/hooks";
import { getFeaturesEnabled } from "@/utils";
import { Box } from "@gemini/core";
import { InvestmentValues } from "./components/InvestmentValues";
import { PriceComparisonLegal } from "./components/PriceComparisonLegal";
import { PriceComparisonSlider } from "./components/PriceComparisonSlider";
export const priceComparisonTestId = "cdp-price-comparison";
export const PriceComparison = () => {
    var _a;
    const { priceComparisonRef } = useRefsContext();
    const { t } = useI18n();
    const { data, hasMainPrice, markerPosition, isSale, priceComparisonLink, pricePerSqm, investmentValues, } = usePriceComparison() || {};
    // adjust marker position to -1 if there is no main price or if the marker position is null
    const adjustedMarkerPosition = hasMainPrice ? markerPosition !== null && markerPosition !== void 0 ? markerPosition : -1 : -1;
    const { priceComparisonRent } = getFeaturesEnabled();
    const showPriceComparison = (_a = useBrandContext()) === null || _a === void 0 ? void 0 : _a.priceLink.comparison;
    if (!showPriceComparison ||
        (!isSale && !priceComparisonRent) ||
        (!data && !investmentValues))
        return null;
    const priceTitle = adjustedMarkerPosition >= 0
        ? "pricecomparison.prices_district_title"
        : "pricecomparison.other_prices_district_title";
    const areasBase = [
        '"sliderArea"',
        pricePerSqm ? '"legalTextArea"' : null,
        (priceComparisonLink === null || priceComparisonLink === void 0 ? void 0 : priceComparisonLink.text) && (priceComparisonLink === null || priceComparisonLink === void 0 ? void 0 : priceComparisonLink.link)
            ? '"locationLinkArea"'
            : null,
        investmentValues ? '"investmentValuesArea"' : null,
    ]
        .filter(Boolean)
        .join(" ");
    const areasRight = [
        investmentValues ? '"investmentValuesArea"' : null,
        pricePerSqm ? '"legalTextArea"' : null,
    ]
        .filter(Boolean)
        .join(" ");
    return (_jsxs(Section, { ref: priceComparisonRef, testId: priceComparisonTestId, unsafeClassname: "HideOnPrint", children: [_jsx(Title, { testId: `${priceComparisonTestId}-title`, variant: "section", title: t("pricecomparison.headline") }), _jsxs(Box, { display: "grid", gridTemplateColumns: {
                    "breakpoint.base": "1fr",
                    "breakpoint.md": `repeat(${investmentValues || pricePerSqm ? 2 : 1}, 1fr)`,
                }, gridTemplateAreas: {
                    "breakpoint.base": areasBase,
                    "breakpoint.md": "none",
                }, gap: {
                    "breakpoint.base": "spacing.24",
                    "breakpoint.md": "spacing.40",
                }, children: [_jsxs(Box, { display: {
                            "breakpoint.base": "contents",
                            "breakpoint.md": data || priceComparisonLink ? "grid" : "none",
                        }, height: "fit-content", gridTemplateColumns: "1fr", gridTemplateAreas: {
                            "breakpoint.md": `"sliderArea" "locationLinkArea"`,
                        }, gap: {
                            "breakpoint.md": "spacing.24",
                        }, children: [_jsxs(Box, { gridArea: "sliderArea", children: [data && adjustedMarkerPosition === -1 && (_jsx(Box, { typography: "typography.body.14.regular", marginBottom: "spacing.12", children: t("pricecomparison.no_prices_district_title") })), (data === null || data === void 0 ? void 0 : data.low) && (data === null || data === void 0 ? void 0 : data.high) && (_jsx(PriceComparisonSlider, { low: data === null || data === void 0 ? void 0 : data.low, high: data === null || data === void 0 ? void 0 : data.high, showPriceComparisonSlider: hasMainPrice, pricePerSqm: pricePerSqm }))] }), (priceComparisonLink === null || priceComparisonLink === void 0 ? void 0 : priceComparisonLink.text) && (priceComparisonLink === null || priceComparisonLink === void 0 ? void 0 : priceComparisonLink.link) && (_jsx(Box, { gridArea: "locationLinkArea", children: _jsx(Box, { backgroundColor: "color.surface.light.default", typography: "typography.body.14.regular", paddingHorizontal: "spacing.12", paddingVertical: "spacing.8", borderRadius: "radius.8", display: "flex", justifyContent: "center", alignItems: "flex-start", children: _jsx(LocationLink, { title: `${t(priceTitle)} ${priceComparisonLink === null || priceComparisonLink === void 0 ? void 0 : priceComparisonLink.text}`, link: priceComparisonLink === null || priceComparisonLink === void 0 ? void 0 : priceComparisonLink.link }) }) }))] }), _jsxs(Box, { display: {
                            "breakpoint.base": "contents",
                            "breakpoint.md": "grid",
                        }, height: "fit-content", gridTemplateColumns: "1fr", gridTemplateAreas: {
                            "breakpoint.md": areasRight,
                        }, gap: {
                            "breakpoint.md": "spacing.24",
                        }, children: [investmentValues && (_jsx(Box, { gridArea: "investmentValuesArea", children: _jsx(InvestmentValues, {}) })), data && pricePerSqm && (_jsx(Box, { gridArea: "legalTextArea", children: _jsx(PriceComparisonLegal, {}) }))] })] })] }));
};
